var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.116,
    height: 122.673,
    viewBox: "0 0 130.116 122.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-math-1935892",
    transform: "translate(-166.375 -105.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M212.229,126.615H194.7V109.09a3.6,3.6,0,0,0-7.2,0v17.525H169.977a3.6,3.6,0,1,0,0,7.2H187.5v17.525a3.6,3.6,0,1,0,7.2,0V133.817h17.525a3.6,3.6,0,0,0,0-7.2Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M388.115,169.987h42.254a3.6,3.6,0,1,0,0-7.2H388.115a3.6,3.6,0,0,0,0,7.2Z",
    transform: "translate(-137.717 -36.172)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M431.018,364.65H388.765a3.6,3.6,0,0,0,0,7.2h42.254a3.6,3.6,0,0,0,0-7.2Z",
    transform: "translate(-138.127 -163.615)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M206.626,342.56l12.483-12.483a3.565,3.565,0,1,0-5.042-5.042L201.584,337.52,189.1,325.035a3.565,3.565,0,1,0-5.042,5.042l12.483,12.483-12.483,12.483a3.482,3.482,0,0,0,0,5.042,4.111,4.111,0,0,0,5.282,0L201.825,347.6l12.483,12.483a4.109,4.109,0,0,0,5.281,0,3.48,3.48,0,0,0,0-5.042Z",
    transform: "translate(-10.482 -137.923)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M447.305,317.261a6,6,0,1,1-6-6,6,6,0,0,1,6,6",
    transform: "translate(-169.78 -129.908)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M447.305,411.674a6,6,0,1,1-6-6,6,6,0,0,1,6,6",
    transform: "translate(-169.78 -189.514)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.99dc8932f56b91474b29b8242f35ce12.svg";
export { ForwardRef as ReactComponent };